const toJSON = (json) => {
	try {
		return JSON.parse(json);
	} catch (error) {
		return null;
	}
};

/**
 * @param {boolean} value
 * @returns {void}
 */
export const setCriticalRecords = (value) => localStorage.setItem('criticalRecords', JSON.stringify(value));

export const getCriticalRecords = () => toJSON(localStorage.getItem('criticalRecords'));

export const clearCriticalRecords = () => localStorage.removeItem('criticalRecords');


export const setHarassmentTendencies = (value) => localStorage.setItem('harassmentTendencies', JSON.stringify(value));

export const getHarassmentTendencies = () => toJSON(localStorage.getItem('harassmentTendencies'));

export const clearHarassmentTendencies = () => localStorage.removeItem('harassmentTendencies');


export const setSuicidalTendencies = (value) => localStorage.setItem('suicidalTendencies', JSON.stringify(value));

export const getSuicidalTendencies = () => toJSON(localStorage.getItem('suicidalTendencies'));

export const clearSuicidalTendencies = () => localStorage.removeItem('suicidalTendencies');


// // set in 15 minutes
// export const setcancleTimeShowSuicidalTendencies = (date) => localStorage.setItem('cancleTimeShowSuicidalTendencies', JSON.stringify(date));

// export const getcancleTimeShowSuicidalTendencies = () => toJSON(localStorage.getItem('cancleTimeShowSuicidalTendencies'));

// export const clearcancleTimeShowSuicidalTendencies = () => localStorage.removeItem('cancleTimeShowSuicidalTendencies');


// // set in 15 minutes
// export const setcancleTimeShowHarassmentTendencies = (date) => localStorage.setItem('cancleTimeShowHarassmentTendencies', JSON.stringify(date));

// export const getcancleTimeShowHarassmentTendencies = () => toJSON(localStorage.getItem('cancleTimeShowHarassmentTendencies'));

// export const clearcancleTimeShowHarassmentTendencies = () => localStorage.removeItem('cancleTimeShowHarassmentTendencies');


// export const getDismissTimestamp = (type) => {
// 	const key = `dismissed_${type}`;
// 	return localStorage.getItem(key);
// };

// export const setDismissTimestamp = (type) => {
// 	const key = `dismissed_${type}`;
// 	localStorage.setItem(key, Date.now());
// };

// export const isDismissedRecently = (type, delayMs = 15 * 60 * 1000) => {
// 	const ts = getDismissTimestamp(type);
// 	if (!ts) return false;
// 	return Date.now() - parseInt(ts, 10) < delayMs;
// };

// export const clearDismissTimestamp = (type) => {
// 	const key = `dismissed_${type}`;
// 	localStorage.removeItem(key);
// };


const DISMISS_KEY = 'dismissed_critical';

export const getDismissTimestamp = () => {
	return localStorage.getItem(DISMISS_KEY);
};

export const setDismissTimestamp = () => {
	localStorage.setItem(DISMISS_KEY, Date.now());
};

export const isDismissedRecently = (delayMs = 15 * 60 * 1000) => {  // 15 minutes
	const ts = getDismissTimestamp();
	if (!ts) return false;
	return Date.now() - parseInt(ts, 10) < delayMs;
};

export const clearDismissTimestamp = () => {
	localStorage.removeItem(DISMISS_KEY);
};
